import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=4beadf3a&scoped=true"
import script from "./doc.vue?vue&type=script&lang=js"
export * from "./doc.vue?vue&type=script&lang=js"
import style0 from "./doc.vue?vue&type=style&index=0&id=4beadf3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beadf3a",
  null
  
)

export default component.exports